//import { url } from "inspector";
import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";
import { CommonBody } from "../types/General";
type CommonResponseType = {
    statusCode: number;
    message: string;
};
type GetAllDietResponse = {
    diet: DietResponse[];
    count: number;
  };
type DietResponse={
    _id:string,
    name:string,
    image:string,
    isBlocked:string
}
type GetTokenParams = {
    // limit?: number;
    page?: number;
    query?: string;
  };

type EncryptedBody = {
  hash: string;
  sek: string;
} | null
export const userApi=emptySplitApi.injectEndpoints({
endpoints:(builder)=>({
getDiets:builder.query<
CommonResponseType & {data:GetAllDietResponse},
    GetTokenParams>({
      
        // query:({page,limit,query})=>{
        query:({page,query})=>{
          let url = END_POINTS.diet;
        const queryParams = [];
        if (page) {
          queryParams.push(`page=${page}`);
        }
        if (query) {
          queryParams.push(`search=${query}`);
        }
        // if (limit) {
        //   queryParams.push(`limit=${limit}`);
        // }
        if (queryParams.length > 0) {
          url += `?${queryParams.join('&')}`;
        }
          return{
            url:url,
            method:'GET',}
        }
}),
getDietById:builder.query<CommonResponseType & {data:DietResponse},
{id:string|undefined}>({
    query:({id})=>({
        url:`${END_POINTS.diet}/${id}`,
        method:"GET",
    })
}),
editDietById: builder.mutation<
      CommonResponseType & { data: DietResponse },
      { id: string|undefined; body: EncryptedBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.diet}/${id}`,
        method: "PUT",
        body,
      }),
    }),

addDiet: builder.mutation<
CommonResponseType & { data: DietResponse },
CommonBody
>({
query: (body) => ({
  url: END_POINTS.diet,
  method: "POST",
  body,
})
}),

deleteDietById:builder.mutation<
CommonResponseType & {data:DietResponse},
{id:string}
>({
    query:({id})=>({
        url:`${END_POINTS.diet}/${id}`,
        method:'DELETE'
    })
}),
getRecipeByDiet:builder.query<CommonResponseType & {data:any},
{id:string}>({
    query:({id})=>({
        url:`${END_POINTS.recipeByDiet}/${id}`,
        method:"GET",
    })
}),
})
})

export const{
 useLazyGetDietsQuery,
 useLazyGetDietByIdQuery,
 useAddDietMutation,
 useDeleteDietByIdMutation,
 useEditDietByIdMutation,
 useLazyGetRecipeByDietQuery
}=userApi;
